import { RequestServerClass } from '@/util/request';
import publishObjectPath from '@/util/configRegistry';
const serverUrl = publishObjectPath.serverUrl;
export class TrainServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  //  培训记录
  // 分页查询所有数据
  public getTrainRecordList(opts: object) {
    const url = serverUrl + '/api/yunnan/train-record';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 培训申请新增
  public trainRequestAdd(opts: object) {
    const url = serverUrl + `/api/yunnan/train-application`;
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 培训申请表格
  public trainRequestTable(opts: object) {
    const url = serverUrl + `/api/yunnan/train-application`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 培训申请查询所有数据
  public trainRequestAllList(opts: object) {
    const url = serverUrl + '/api/yunnan/train-application/list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 详情
  public infoTrainRequestData(id: string) {
    const url = serverUrl + `/api/yunnan/train-application/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 培训申请编辑
  public trainRequestEdit(id: string, opts: any) {
    const url = serverUrl + `/api/yunnan/train-application/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }
  // 培训申请删除
  public trainRequestDelete(id: string) {
    const url = serverUrl + `/api/yunnan/train-application/${id}`;
    return this.rSerivce.serverObj.delete(url);
  }

  // 新增数据
  public addTrainRecordData(opts: object) {
    const url = serverUrl + '/api/yunnan/train-record';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 详情
  public infoTrainRecordData(id: string) {
    const url = serverUrl + `/api/yunnan/train-record/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 编辑
  public editTrainRecordData(id: any, opts: object) {
    const url = serverUrl + `/api/yunnan/train-record/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }
  // 删除
  public delTrainRecordData(id: any) {
    const url = serverUrl + `/api/yunnan/train-record/${id}`;
    return this.rSerivce.serverObj.delete(url);
  }
  // 参训人员
  // 新增
  public addTrainTraineeData(opts: object) {
    const url = serverUrl + '/api/yunnan/train-trainee';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 删除
  public delTrainTraineeData(id: any) {
    const url = serverUrl + `/api/yunnan/train-trainee/${id}`;
    return this.rSerivce.serverObj.delete(url);
  }
}
